<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="添加好友"
    width="500px"
    
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="100px" :inline="true">
        <el-form-item label="手机号" prop="mobile" >  
          <el-input  type="text" v-model="formData.mobile" placeholder="输入手机号搜索"></el-input> 
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>


    <div class="table_form" v-for="(item,index) in userList " :key="index">
      <section>
        <img :src="item.user_avatar" alt="" />
        <div>
          <b>{{ item.name }}</b>
          <p>
            <span>兼职号：{{item.jz_number}}</span>
          </p>
        </div>
      </section>
      <el-button type="primary" @click="addFriend">邀请</el-button>
    </div>

    <el-empty description="暂无数据"  v-if="userList.length<=0"></el-empty>


    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>


  </el-dialog>
</template>

<script>
import {addFriendApi } from  "@/api/relation/index.js";

export default {
  components: { },

  data() {
    return {
      visible: false,
      userList:[],
      formData: {
        mobile:"",
      },
       rules: {
        mobile: [
              {required: true, message: '请输入手机号', trigger: 'blur'}
          ],
       }
    };
  },

 
  mounted() {
    console.log("asdasdasd")

},
  
  methods: {
    onSubmit() {
        console.log('submit!');
      },

      addFriend(){

      },
    handleClose() {
      this.$refs["form"].resetFields();
      this.visible = false;

    },


    init() {
      this.visible = true;
    },

   
    
    
    submit(){
      var that=this;

      this.$refs["form"].validate((valid) => {
          if (valid) {
            addFriendApi(that.formData).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'

                });
                that.$emit('refresh');
                that.visible = false;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          } 
        });

    },

    
  },

 
};
</script>

<style lang="scss" scoped>



::v-deep .myWindow {
    border-radius: 15px;



/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }

  .table_form {
    width: 100%;
    height: 68px;
    box-sizing: border-box;
    border-radius: 6px;
    border: 1px solid #cccccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    margin-bottom: 19px;
  section {
    display: flex;
    img {
      width: 43px;
      height: 43px;
      margin-right: 15px;
    }
    div {
      height: 43px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      b {
        font-size: 16px;
        color: #333;
      }
      span {
        font-size: 11px;
        margin-right: 20px;
        color: #666;
      }
    }
  }
}
</style>
